import { Box, HStack, Icon, Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import Picture from 'components/picture';
import { primitive } from 'styles/constants/primitives';

export const MAP_HEIGHT = '300px';

export const StyledLink = Link.withConfig({
  isInline: false,
  _text: {
    variant: 'copyOne',
    color: Styles.color.red,
    fontSize: 'sm',
    lineHeight: 'sm',
    fontWeight: 'bold',
  },
  marginBottom: { base: '$4', md: '$12' },
  marginTop: { base: '$4', md: '$8' },
});

export const LocationContainer = Box.withConfig({
  shadow: '1',
  borderRadius: Styles.borderRadius,
  paddingY: '$4',
  paddingX: '$8',
  marginBottom: { base: '$4', md: '$12' },
  width: 'full',
  backgroundColor: Styles.color.cardBackground,
});

export const StreetAddress = Text.withConfig({
  variant: 'copyOne',
  fontSize: 'md',
  lineHeight: 'md',
  fontWeight: 'bold',
});

export const Address = HStack.withConfig({
  textTransform: 'capitalize',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const StyledPicture = Picture.withConfig({
  height: MAP_HEIGHT,
  width: 'full',
});

export const ServiceModeContainer = Box.withConfig({
  flexDirection: 'row',
  mb: '$0.5',
});

export const ServiceModeIcon = Icon.withConfig({
  size: 'sm',
  lineHeight: '$6',
  color: primitive.bk.$crunchyGreen,
});

export const ServiceModeHeading = Text.withConfig({
  variant: 'headerThreeLook',
  margin: 0,
  color: primitive.bk.$crunchyGreen,
  ml: '$1',
  display: 'flex',
  alignSelf: 'end',
});
